import Api from './api';

const slug = 'v1/roleplay-sessions';
export default {
  createRoleplaySession(roleplaySessionData) {
    return new Promise((resolve, reject) => {
        Api.post(`/${slug}/`, roleplaySessionData)
          .then(res => resolve(res.data))
          .catch((err) => {
            reject(err);
          });
      }
    );
  },
  getRoleplaySessions() {
    return new Promise((resolve, reject) => {
        Api.get(`/${slug}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      }
    );
  },
  getRoleplaySession(sessionId) {
    return new Promise((resolve, reject) => {
        Api.get(`/${slug}/${sessionId}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      }
    );
  },
  restartRoleplaySession(sessionId) {
    return new Promise((resolve, reject) => {
        Api.post(`/${slug}/${sessionId}/restart`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      }
    );
  },
  updateRoleplaySession(sessionId, updateData) {
    return new Promise((resolve, reject) => {
        Api.put(`/${slug}/${sessionId}`, updateData)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      }
    );
  },
  deleteRoleplaySession(sessionId) {
    return new Promise((resolve, reject) => {
        Api.delete(`/${slug}/${sessionId}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
    });
  },
  generateQuickRoleplay(data) {
    return new Promise((resolve, reject) => {
        Api.post(`/${slug}/quick`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
    });
  },
  generateRoleplayFromVideo(videoId) {
    return new Promise((resolve, reject) => {
        Api.post(`/${slug}/from-video`, { videoId })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
    });
  },
  updateQuickPlaceholders(sessionId, placeholders) {
    return new Promise((resolve, reject) => {
        Api.patch(`/${slug}/${sessionId}/placeholders`, { placeholders })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
    });
  },
  prepareRoleplaySession(sessionId) {
    return new Promise((resolve, reject) => {
        Api.post(`/${slug}/${sessionId}/instructions`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
    });
  },
  createOmniaCall(sessionId, data) {
    return new Promise((resolve, reject) => {
        Api.post(`/${slug}/${sessionId}/omnia-call`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
    });
  }
}
